import React, { lazy } from 'react'
import { Route } from 'react-router'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// La liste est à la flotte ; la fiche s'ouvre aussi au client, depuis l'onglet de son avion (le serveur filtre, I5).
export const MaintenanceWorkOrderRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet', 'role--maintenance--client']}>
    <Route path='file/:workOrderId/*' element={<Detail />} />
    <Route
      path='*'
      element={
        <LoggedInRoute roles={['role--maintenance--fleet']}>
          <Index />
        </LoggedInRoute>
      }
    />
  </SubRouter>
))
